import { Eye, User, Warning } from "phosphor-react";
import React, { useState } from "react";
import BillsApi from "~/admin/apis/bills.api";
import Card from "~/admin/components/Card";
import PageDataLoader from "~/admin/components/PageDataLoader";
import Pagination from "~/admin/components/Pagination";
import Table from "~/admin/components/Table";
import Td from "~/admin/components/Td";
import Th from "~/admin/components/Th";
import Tr from "~/admin/components/Tr";
import useDataLoading from "~/admin/hooks/useDataLoading";
import useLayout from "~/hooks/useLayout";
import useMount from "~/hooks/useMount";
import moment from "moment";
import useNavigation from "~/admin/hooks/useNavigation";

export default function BillsPage() {
  const { setLayout } = useLayout();
  const dataLoading = useDataLoading();
  const [bills, setBills] = useState([]);
  const { navigate } = useNavigation();

  useMount(() => {
    setLayout({
      title: "Factures",
      activeMenuKeys: ["bills"],
    });
    loadData();
  });

  const loadData = async () => {
    dataLoading.start();
    setBills([]);

    let error = null;
    const data = await BillsApi.paginate().catch((e) => {
      error = e;
      return null;
    });

    dataLoading.stop(error);
    if (data) {
      setBills(data);
    }
  };

  const search = async (page = 1) => {
    let bills = await BillsApi.paginate(page).catch((e) => {
      return null;
    });

    if (bills) {
      setBills(bills);
    }
  };

  const onPaginate = (page) => {
    search(page);
  };

  return (
    <PageDataLoader isLoading={dataLoading.isLoading}>
      <div className="w-full h-screen text-white flex flex-col">
        <div className="w-full min-h-[60px] border-b-2 border-slate-700 flex justify-end items-center px-10">
          <div className="font-bold text-2xl">Factures</div>
        </div>
        <div className="p-6 overflow-auto">
          {bills && bills.items?.length > 0 ? (
            <Card>
              <Table>
                <thead>
                  <Tr>
                    <Th>Total ttc</Th>
                    <Th>Total ht</Th>
                    <Th>Engagement</Th>
                    <Th>Date</Th>
                    <Th adaptToContent></Th>
                  </Tr>
                </thead>
                <tbody>
                  {bills.items.map((bill) => {
                    return (
                      <Tr key={bill.id}>
                        <Td>{bill.totalTtc}</Td>
                        <Td>{bill.totalHt}</Td>
                        <Td>{bill.oneYearCommitment ? "Oui" : "Non"}</Td>
                        <Td>{moment(bill.createdAt).format("DD/MM/YYYY")}</Td>
                        <Td>
                          <div className="flex gap-x-2">
                            <User
                              className="cursor-pointer hover:text-gray-400"
                              onClick={() => {
                                bill.user.userable_type ===
                                "App\\Models\\Company"
                                  ? navigate(`companies/${bill.user.id}`)
                                  : navigate(`influencer/${bill.user.id}`);
                              }}
                              size={24}
                            />
                            <a
                              target="_blank"
                              rel="noreferrer"
                              href={bill.staticFileUrl}
                            >
                              <Eye
                                className="cursor-pointer hover:text-gray-400"
                                size={24}
                              />
                            </a>
                          </div>
                        </Td>
                      </Tr>
                    );
                  })}
                </tbody>
              </Table>
              {bills.items && (
                <div className="pt-4 text-center">
                  <Pagination
                    lastPage={bills.lastPage}
                    currentPage={bills.currentPage}
                    onPaginate={onPaginate}
                  />
                </div>
              )}
            </Card>
          ) : (
            <div className="px-4 py-2 bg-orange-300 text-orange-700 w-fit rounded-md mx-auto flex space-x-4 items-center">
              <div className="rounded-full border w-fit border-orange-700 h-fit">
                <Warning />
              </div>
              <div>Aucunes factures pour le moment !</div>
            </div>
          )}
        </div>
      </div>
    </PageDataLoader>
  );
}
